import { useQuery } from '@tanstack/react-query';
import { getManagerial } from '../services/managerialService';

export const useManagerial = (month: string = '2025-04') => {
  return useQuery({
    queryKey: ['ecomm-managerial-dashboard', month],
    queryFn: () => getManagerial(month),
    staleTime: 1000 * 60 * 5, 
  });
};
